import React from "react";
import { BR, ES, US } from "country-flag-icons/react/3x2";

const FLAG_COMPONENTS = {
  pt: BR,
  en: US,
  es: ES,
};

export function LanguageFlag({ lang, className }) {
  const Flag = FLAG_COMPONENTS[lang];
  if (!Flag) return null;

  return <Flag className={className} aria-hidden focusable="false" />;
}
